import { render } from "./ReportDetailTransaction.vue?vue&type=template&id=2035332b"
import script from "./ReportDetailTransaction.vue?vue&type=script&lang=js"
export * from "./ReportDetailTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__